import { Model }            from '@mathquis/modelx';
import { computed }         from 'mobx';
import currentSession       from 'utils/currentSession';
import { FileConnector }    from 'connectors/FileConnector';
import type ConnectorResult from '@mathquis/modelx/lib/types/connectorResult';
import ConfigProxy          from 'utils/ConfigProxy';

export const connector = new FileConnector({
  baseURL: ConfigProxy.get('API_ENTRYPOINT'),
});

connector.setCurrentSessionStore(currentSession);

export default class FileModel extends Model {
  static get connector() {
    return connector;
  }

  public data: any;
  public headers: any;
  public res: any;

  onFetchSuccess(result: ConnectorResult, options: object) {
    super.onFetchSuccess(result, options);
    this.data = result.res.data;
    this.headers = result.res.headers;
  }

  onSaveSuccess(connectorResult: ConnectorResult, options: object) {
    super.onSaveSuccess(connectorResult, options);
    this.data = connectorResult.res.data;
    this.res = connectorResult.res;
  }

  patch(attributes = {}, options = {}): Promise<Model> {
    return this.save({ ...options, patchAttributes: attributes });
  }

  // get id() {
  //   return this.get('id');
  // }

  @computed
  get iri() {
    return this.get('@id');
  }
}
